import { GET_USER, GET_USER_REPORTS } from '../constants/ActionTypes'

const INITIAL_STATE = {
	data: [],
	reports: []
}

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case GET_USER:
			return {
				...state,
				data: action.payload
			}
		case GET_USER_REPORTS:
			return {
				...state,
				reports: action.payload
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/auth_user.js